module.exports = __webpack_public_path__ + "static/media/statistics-desktop-right-top-bg.bc797040.svg";